import { Box, Button, Grid2, styled } from "@mui/material";
import React, { useState, useEffect } from "react";
// import Header from "../Header/Header";
import SideBar from "../SideBar/SideBar";
import Switch from "@mui/material/Switch";
// import "../../Styles.css";
import "./Component.css";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import { deepOrange, deepPurple } from '@mui/material/colors';
import Favorite from "@mui/icons-material/Favorite";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Link, useNavigate } from "react-router-dom";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Rating from "@mui/material/Rating";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";

const steps = [
  "Receiving orders",
  "Order processing",
  "Being delivered",
  "Delivered",
];

const drawerWidth = 240;
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const SubAdmin = () => {
  const navigate = useNavigate();

  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const [value, setValue] = React.useState("female");

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <div className="add-product">
      <Box sx={{ display: "flex" }}>
        <SideBar />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 5,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Button</h2>
                <div className="white-btn">
                  <Button
                    onClick={() => {
                      navigate("");
                    }}
                  >
                    {" "}
                    Add Product
                  </Button>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Badges</h2>
                <p className="mt-10">Use class .block-not-available</p>
                <div className="block-not-available">Not Available</div>
                <p className="mt-10">Use class .block-available</p>
                <div className="block-available">Available</div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Alert</h2>
                <Stack sx={{ width: "100%" }} spacing={2}>
                  <Alert severity="success">This is a success Alert.</Alert>
                  <Alert severity="info">This is an info Alert.</Alert>
                  <Alert severity="warning">This is a warning Alert.</Alert>
                  <Alert severity="error">This is an error Alert.</Alert>
                </Stack>
              </div>
            </Grid2>

            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>TextField</h2>
                <div className="prd-info-txt">
                  <TextField
                    id="outlined-basic"
                    placeholder="Attribute name"
                    variant="outlined"
                    name="text"
                    type="text"
                    sx={{ width: "100%" }}
                  />
                </div>

                <div className="prd-info-txt">
                  <FormControl sx={{ mt: 1 }} variant="outlined">
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>

                <div className="prd-info-txt mt-10">
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      onChange={handleChange}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "var(--clr-font);" }}>Checkbox</h2>
                <div className="prd-info-txt mt-10">
                  <Checkbox className="svg-icon" {...label} />
                  <br></br>

                  <FormControlLabel
                    required
                    control={<Checkbox className="svg-icon" />}
                    style={{ color: "var(--clr-font);" }}
                    label="Required"
                  />
                </div>
                <div>
                  <Checkbox
                    className="svg-icon"
                    {...label}
                    icon={<FavoriteBorder />}
                    checkedIcon={<Favorite />}
                  />
                  <Checkbox
                    className="svg-icon"
                    {...label}
                    icon={<BookmarkBorderIcon />}
                    checkedIcon={<BookmarkIcon />}
                  />
                </div>

                <h2 style={{ color: "#94a3b8" }}>Radio Button</h2>
                <FormControl style={{ color: "var(--clr-font);" }}>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label="Female"
                    />
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      label="Male"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Rating</h2>
                <Rating
                  name="half-rating"
                  defaultValue={2.5}
                  precision={0.5}
                  className="star-label"
                />
                <h2 style={{ color: "#94a3b8" }}>Switch</h2>
                <Switch />
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Stepper</h2>
                <div className="stepper-cnt">
                  <Stepper activeStep={1} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Tabs</h2>
                <div className="tab-common">
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                      value={tab}
                      onChange={handleTabChange}
                      aria-label="basic tabs example"
                    >
                      <Tab label="Item One" {...a11yProps(0)} />
                      <Tab label="Item Two" {...a11yProps(1)} />
                      <Tab label="Item Three" {...a11yProps(2)} />
                    </Tabs>
                  </Box>
                  <CustomTabPanel value={tab} index={0}>
                    Item One
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={1}>
                    Item Two
                  </CustomTabPanel>
                  <CustomTabPanel value={tab} index={2}>
                    Item Three
                  </CustomTabPanel>
                </div>
              </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
              <div className="bg-dash-default">
                <h2 style={{ color: "#94a3b8" }}>Avatar</h2>
                <div className="display-2">
                <div className="">
                  <h2 style={{ color: "#94a3b8" }}>Group Avatar</h2>
                  <AvatarGroup max={4} className="group-avartar">
                    <Avatar
                      alt="Remy Sharp"
                      src="/static/images/avatar/1.jpg"
                    />
                    <Avatar
                      alt="Travis Howard"
                      src="/static/images/avatar/2.jpg"
                    />
                    <Avatar
                      alt="Cindy Baker"
                      src="/static/images/avatar/3.jpg"
                    />
                    <Avatar
                      alt="Agnes Walker"
                      src="/static/images/avatar/4.jpg"
                    />
                    <Avatar
                      alt="Trevor Henderson"
                      src="/static/images/avatar/5.jpg"
                    />
                  </AvatarGroup>
                </div>
                <div className="">
                <h2 style={{ color: "#94a3b8" }}>Avatar</h2>
                <Avatar sx={{ bgcolor: deepOrange[500] }}>N</Avatar>
                </div>
                </div>

              </div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  );
};

export default SubAdmin;
